module.exports = __webpack_public_path__ + "img/Componente 34 – 1.7d861858.svg";